import { ThemeProvider } from '@mui/material/styles';
import { createRoot } from 'react-dom/client';
import React from 'react';
import { App } from './App';
import theme from './theme';

const root = createRoot(document.getElementById("root") as HTMLElement);
root.render(<ThemeProvider theme={theme}><App /></ThemeProvider >);